var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-dialogContainer"},[_c('div',[_c('BaseBusiness',{ref:"base",attrs:{"formParams":_vm.formParamsBase,"reMountPage":_vm.reMount}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }